var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelope28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 16,
  x: 3,
  y: 6,
  stroke: "currentColor",
  rx: 2,
  ry: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  d: "m3 8 11 6 11-6"
})));
export { SvgEnvelope28 as ReactComponent };
export default __webpack_public_path__ + "182e76a5a1dbe6c15e3bb900879884d5.svg";